import React from 'react';
import Contact from './Contact';

const ContactPage = () => {
    return (
        <div>
            <Contact />
        </div>
    );
};

export default ContactPage;